import { OfferPaywallsState } from './types';

const initialState: OfferPaywallsState = { offerPaywalls: [], expiresAt: 0 };

export default initialState;
